module.exports = __webpack_public_path__ + "static/img/Frame 18213.e71a6fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper3/Frame 18213.png
// module id = IEnv
// module chunks = 12